import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {catchError} from 'rxjs/operators';
import {JwtService, OauthService} from 'mclane-webauth-lib';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';

@Injectable({
    providedIn: 'root'
})
export class StoreListResolver  {
    constructor(private jwtService: JwtService, private oauthService: OauthService, private storeListService: StoreListService,
                private loadingIndicatorHelper: LoadingIndicatorHelper, private dialogHelper: DialogHelperComponent, private router: Router) { }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(this.storeListService.storeList == null) {
            this.loadingIndicatorHelper.show({});
            return this.storeListService.load(this.jwtService.preferred_username.toUpperCase()).catch((error) => {
                localStorage.clear();
                console.error(error);
                this.dialogHelper.showNoStoresDialog().then(() => {
                    this.router.navigateByUrl('no-stores');
                });
            }).finally(() => {
                this.loadingIndicatorHelper.hide();
            });
        }else {
            return true;
        }
    }
}
